import React, { useState, useEffect } from "react";
import { NativeSelect, Paper } from "@material-ui/core";
import api from "../../../../services/api";
import "../../TargetReport/TableContent/index.css";
import { useMessageBox } from "../../../../context/MessageBox";
import { toast } from "react-toastify";
import * as S from './formStyle';
import Loading from '../../../../components/Loading';

function OperationsMiddle({
    setFilterData,
    setTitle,
    setIsLoading,
    isLoading,
    idDynamic,
    setGrid1,
    setGrid2,
    setGrid3,
    setGrid1Info,
    setGrid2Info,
    setGrid3Info,
    setFilterRenderData,
    setCurrentReport,
    setCurrentSelected,
    setCanShowSelect
}) {
  const classes = S.useStyles();
  const [triggerUpdate, setTriggerUpdate] = useState(true);
  const [relatorioDinamico, setRelatorioDinamico] = useState(0);
  const [relatorioOpcoes, setRelatoriosOpcoes] = useState([]);
  const screenParams = {
    title: "Relatórios Dinâmicos",
    apiFiltros: "RelatoriosDinamicosFiltros",
    dateFormat: "dd/MM/yyyy",
  };

  const { setMessageData } = useMessageBox();

  useEffect(async () => {
    setGrid1({});
    setGrid2({});
    setGrid3({});
    setGrid1Info({
      gridInstrucaoSql: "",
      gridInstrucaoSqlTotalizador: "",
      gridTitulo: "",
      gridTituloAlinhamentoHorizontal: "",
      gridTituloAlinhamentoVertical: "",
      gridTituloCorFonte: "",
      gridTituloCorFundo: "",
      gridTituloFonteBold: false,
      gridTotalizador: "",
      gridVisivel: false,
    })
    setGrid2Info({
      gridInstrucaoSql: "",
      gridInstrucaoSqlTotalizador: "",
      gridTitulo: "",
      gridTituloAlinhamentoHorizontal: "",
      gridTituloAlinhamentoVertical: "",
      gridTituloCorFonte: "",
      gridTituloCorFundo: "",
      gridTituloFonteBold: false,
      gridTotalizador: "",
      gridVisivel: false,
    })
    setGrid3Info({
      gridInstrucaoSql: "",
      gridInstrucaoSqlTotalizador: "",
      gridTitulo: "",
      gridTituloAlinhamentoHorizontal: "",
      gridTituloAlinhamentoVertical: "",
      gridTituloCorFonte: "",
      gridTituloCorFundo: "",
      gridTituloFonteBold: false,
      gridTotalizador: "",
      gridVisivel: false,
    })
    if (triggerUpdate && relatorioDinamico && Number(relatorioDinamico) !== 0) {
      await getReportSelected();
      changeBotoes();
      setCurrentSelected(Number(relatorioDinamico))
      if(idDynamic) {
        setCanShowSelect(false)
      }
    } else if (Number(relatorioDinamico) === 0) {
      setFilterData([]);
      setFilterRenderData([]);
      setCurrentReport({})
      setCurrentSelected(0)
    }
    changeTitle(relatorioDinamico)
  }, [relatorioDinamico]);

  useEffect(() => {
    const initialize = async () => {
      await fetchRelatoriosDinamicos();
      if(idDynamic){
        setRelatorioDinamico(Number(idDynamic))
        setTriggerUpdate(true);
      }
    };
    initialize();
  }, []);

  const fetchRelatoriosDinamicos = async () => {
    setIsLoading(true);

    try {
      const relatorios = await api.get('RelatoriosDinamicos/Consultar?paginaInicial=0&itensPorPagina=0&&status=Ativo')
      if(relatorios && relatorios.data && relatorios.data.status == 'Sucesso') {
        setRelatoriosOpcoes(relatorios.data.resposta)
      }
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  }

  const changeBotoes = () => {
    const relatorio = relatorioOpcoes.find(x => x.relatorioDinamicoId === Number(relatorioDinamico))
    setCurrentReport(relatorio)
  }

  const changeTitle = (value) => {
    const relatorio = relatorioOpcoes.find(x => x.relatorioDinamicoId === Number(value))
    const title  = relatorio?.tituloRelatorio ? relatorio.tituloRelatorio : 'Relatório Dinâmicos';
    setTitle(title)
  }

  const getReportSelected = async () => {
    setIsLoading(true);
    setFilterData([]);
    setFilterRenderData([]);

    try {
      const relatorio = await api.get(`${screenParams.apiFiltros}/ConsultarRelatorioDinamicoId?relatorioDinamicoId=${relatorioDinamico}`);

      if (relatorio?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(relatorio?.data?.complemento?.mensagensBox);
      }

      if (relatorio.data.status !== "Sucesso" || relatorio.data.complemento.codigo === '204') {
        if (relatorio.data.resposta && relatorio.data.complemento.codigo !== '204') {
          if (relatorio.data.resposta.length > 0) {
            relatorio.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
        setFilterData([]);
        setFilterRenderData([]);
      } else {
        setFilterData(relatorio.data.resposta);
        let renderArray = []
        relatorio.data.resposta.map((item) => {
          if(renderArray[item.linhaTelaFront]?.length > 0) {
            renderArray[item.linhaTelaFront].push(item)
          } else {
            renderArray[item.linhaTelaFront] = [item]
          }
        })
        setFilterRenderData(renderArray)
      }

    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div style={{ height: "100%", width:'100%', display: 'flex', justifyContent: 'space-between' }}>
        {!idDynamic ? (<div
          className='new-body-schedule'
          style={{
            width: "100%",
            display: "flex",
            marginTop: "20px",
            alignItems: 'center',
            height: '100%',
            border: '2px solid #ddd',
            borderRadius: '8px',
            backgroundColor: '#eee',
            padding: '20px',
            height: '100%'
        }}>
          <p></p>
          <div style={{ width: '500px' }}>
            <label className={classes.label}>Relatorios Dinâmicos</label>
            <Paper className={classes.medium} elevation={0}>
              <NativeSelect
                name="relatoriosDinamicos"
                className={classes.input}
                disabled={isLoading || idDynamic}
                onChange={(e) => {
                    setRelatorioDinamico(e.target.value)
                    setTriggerUpdate(true);
                }}
                value={relatorioDinamico}
              >
              <option value={0}>Relatorios Dinâmicos</option>
              {relatorioOpcoes.map((relatorio) => (
                <option key={relatorio.relatorioDinamicoId} value={relatorio.relatorioDinamicoId}>
                    {relatorio.relatorio}
                </option>
              ))}
            </NativeSelect>
          </Paper>
        </div>
      </div>) : (
        <><Loading /></>
      )}
    </div>
    </>
  );
}

export default OperationsMiddle;
